import { PdpSettings } from '@spa/lib/store/settings/PdpSettings';
import { RootState } from '../../RootState';

const selectPdpSettings = (state: RootState): PdpSettings => {
  const settings = state.settings.settings;

  if (settings === null) {
    throw new Error('PDP settings should be initialized.');
  }

  return (
    settings.pdpSettings ?? {
      pdpShowVideosEnabled: false,
      pdpShowExternalContentEnabled: false
    }
  );
};

export default selectPdpSettings;
